import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { WorkspaceLayout } from '../../components/layout/WorkspaceLayout';
import { DeploymentsManager } from '../../features/deployments/DeploymentsManager';
import { useAppDispatch, useAppSelector } from '../../hooks/useAppRedux';
import { useI18n } from '../../hooks/useI18n';
import { fetchProjectById, setSelectedProjectId } from '../../redux/slices/projectsSlice';

export const DeploymentsPage = () => {
  const { projectId = '' } = useParams();
  const dispatch = useAppDispatch();
  const { t } = useI18n();
  const [status, setStatus] = useState('loading');
  const { items } = useAppSelector((state) => state.projects);
  const project = items.find((item) => item.id === projectId) || null;

  useEffect(() => {
    if (!projectId) {
      setStatus('not-found');
      return;
    }

    let cancelled = false;
    setStatus('loading');
    dispatch(setSelectedProjectId(projectId));

    dispatch(fetchProjectById(projectId))
      .unwrap()
      .then(() => {
        if (!cancelled) {
          setStatus('ready');
        }
      })
      .catch(() => {
        if (!cancelled) {
          setStatus('not-found');
        }
      });

    return () => {
      cancelled = true;
    };
  }, [dispatch, projectId]);

  if (status === 'not-found' || (!project && status !== 'loading')) {
    return <div className="p-10 text-center text-lg">{t('projectNotFound')}</div>;
  }

  const layoutProject = project || { id: projectId, name: t('deploymentsTitle') };
  const isWorkspaceLoading = status === 'loading';

  return (
    <WorkspaceLayout project={layoutProject} backTo={`/workspace/${projectId}`} activeSection="publish">
      <DeploymentsManager
        projectId={projectId}
        project={project}
        forceLoading={isWorkspaceLoading}
        disableFetch={isWorkspaceLoading}
      />
    </WorkspaceLayout>
  );
};
